import React from "react";
import { useTranslation } from "react-i18next";
import { FaCheckCircle } from "react-icons/fa";
import Heading from "../../../Components/Heading/Heading";
import { getOnboardingUrl } from "../../../utils/portalUrl";
import styles from "./GetPaid.module.css";
import payImg from "../../../assets/home_payments.png";

const GetPaid = () => {
  const { t } = useTranslation();
  return (
    <section className={styles.mainBox}>
      <div className={`container ${styles.parent}`}>
        <section className={styles.child1} data-aos="fade-up" data-aos-duration="500">
          <div className={styles.headingBox}>
            <Heading text={t("getPaid.heading")} />
          </div>
          <p className={styles.para}>{t("getPaid.subtitle")}</p>
          <ul className={styles.points}>
            {["p1", "p2", "p3"].map((k) => (
              <li key={k}><FaCheckCircle className={styles.check} /> {t(`getPaid.${k}`)}</li>
            ))}
          </ul>
          <a href={getOnboardingUrl("cta")} className={styles.cta}>{t("getPaid.cta")}</a>
        </section>
        <section className={styles.child2} data-aos="fade-up" data-aos-duration="500">
          <img src={payImg} alt="" className={styles.img} loading="lazy" />
        </section>
      </div>
    </section>
  );
};

export default GetPaid;
